package music.jammers.shared.event.domain.model

import kotlinx.serialization.Serializable
import music.jammers.shared.instrument.domain.model.InstrumentType

@Serializable
data class EventInstrument(
    val instrument: InstrumentType,
    val status: Status,
    val id: Long = -1,
) {

    enum class Status {
        REQUIRED,
        OPTIONAL,
    }
}
